<template>
<!-- eslint-disable -->
    <div v-show="!title" class="fixed h-screen w-full bg-white bg-opacity-80 z-50 flex justify-center items-center"> 
      <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-theme-sky"></div>
    </div>
    <div class="flex-grow">
        <div class="bg-theme-light">
        <div class="section container px-6 py-16 mx-auto">
            <div class="items-center lg:flex">
                <div class="w-full flex flex-col jusctify-center text-center">
                    <h1 class="text-5xl text-theme-blue font-semibold">{{title}}</h1>
                    <h4 class="text-gray-900 text-xl w-11/12 md:w-9/12 m-auto text-center font-normal py-6">{{subtitle}}</h4>
                </div>
            </div>
        </div>
        </div> 

        <div v-show="title" class="section container mx-auto py-20">
            <div class="grid grid-cols-4 gap">
                <div class="col-span-4">
                    <div class="mapa flex justify-evenly z-10">
                        <img class="w-full" :src="img_mapa" >
                    </div>
                </div>
            </div>
        </div> 

        <div v-show="title" class="section container mx-auto py-20">
            <div class="grid grid-col-2 md:grid-cols-4 gap w-4/5 mx-auto">
                <div v-show="content1" class="col-span-2 content">
                    <h3 class="text-3xl text-theme-blue font-semibold">PADRINOS DEL PROYECTO</h3>
                    <div v-html="content1"></div>
                </div>
                <div v-show="content2" class="col-span-2 content" v-html="content2">

                </div>

            </div>
        </div> 

    </div>   
</template>


<script>

export default {
    name: "LibrosCirculan",
    components: {
        // Slider,
        // Intro,
        //Content
    },
    
    data(){
        const img_mapa = require('@/assets/images/home/mapa3.jpg')

        return{
            title:"",
            subtitle:"",
            content1:"",
            content2:"",
            img_mapa
        }
    },

    methods: {
        async getContent(view){
            var filter = `?view=${view}`
            var get = `${process.env.VUE_APP_URL_CULTURAPP}api/contents${filter}`
            const response = await fetch(get,{method: 'GET'})
            const contents = await response.json()

            this.title = contents.filter(obj => obj.section == 'header' && obj.element == 'title')[0].content
            this.subtitle = contents.filter(obj => obj.section == 'header' && obj.element == 'subtitle')[0].content
            
            this.content1 = contents.filter(obj => obj.section == 'main' && obj.element == 'content1')[0].content
            this.content2 = contents.filter(obj => obj.section == 'main' && obj.element == 'content2')[0].content
        }, 
    },
    mounted () {
        window.scrollTo(0, 0)
    }, 
    created(){
        this.getContent('librosqc')
    }
};
</script>

<style scoped>

.content strong {
    color: #142c7a;
    font-size: 1.1em;
}
.content ul {
    padding: 1em 0px;
}

.content ul li {
    padding: 0.4rem 0rem;
    margin-left: 3rem;
    list-style: disc;
    margin-top: 0.5rem;
}

li {
    padding: 0.4rem 0rem;
    margin-left: 3rem;
    list-style: disc;
    margin-top: 3rem;
}
</style>